import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    paper: () => ({
      borderRadius: '10px',
      border: '1px solid #D4D8E3',
    }),
  },
};
